import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  redirect(campaign) {
    this.router.transitionTo(
      campaign.isApiTriggered ? 'broadcasts.broadcast.setup.recipients' : 'campaigns.campaign.setup.trigger',
    );
  }
}
